import { render, staticRenderFns } from "./BlackoutBanner.vue?vue&type=template&id=33a4011f&scoped=true"
import script from "./BlackoutBanner.vue?vue&type=script&lang=js"
export * from "./BlackoutBanner.vue?vue&type=script&lang=js"
import style0 from "./BlackoutBanner.vue?vue&type=style&index=0&id=33a4011f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a4011f",
  null
  
)

export default component.exports